export default "__VITE_ASSET__Co1kOA4m__"